import { useTranslations } from "next-intl";
import { useCurrentUser } from "@hooks/use-current-user";
import { Button, Link, Image } from "@components/core";
import GiftCardLayout from "../Shared/GiftCardLayout";
import GiftCardRedeemCode from "./GiftCardRedeemCode";

const GiftCardRedeem = () => {
  const t = useTranslations("gift_cards");

  const user = useCurrentUser();

  if (user === null) {
    return (
      <div className="text-center m-4 py-4 px-2 m-md-0 p-md-0">
        <div className="redeem-container">
          <Image
            src="giftCardDesktop"
            alt={t("redeem_alt")}
            className="redeem-img-desktop"
          />
          <div className="d-flex flex-column justify-content-center align-items-center mx-auto">
            <h1 className="h4 mb-4 pt-3 px-md-2">{t("please_be_connected")}</h1>
            <Link href="/sign-in?redirect=activate_gift_cards">
              <Button className="gift-card-btn mt-3 mb-3">
                {t("i_sign_in")}
              </Button>
            </Link>
            <div className="my-4 mx-auto font-size-lg redeem-small-container">
              <p className="mb-0">{t("new_here")}</p>
              <Link
                href="/sign-up?redirect=activate_gift_cards"
                className="mb-0 link-primary"
              >
                {t("inscription_link")}
              </Link>
              <p className="mb-0">{t("activation_code")}</p>
            </div>
          </div>
        </div>
      </div>
    );
  }
  return (
    <GiftCardLayout>
      <div className="text-center py-4 px-2">
        <h1 className="h3 mb-2">{t("activate_my_gift_card")}</h1>
      </div>
      <GiftCardRedeemCode />
    </GiftCardLayout>
  );
};

export default GiftCardRedeem;
